import { Language } from "@/data/model/Enums";

import { clientLanguage } from "@/shared/localization/language";

export let trans: {
    cancellation: {
        cancellationSuccessful: string;
        cancel: string;
    };
    login: {
        title: string;
        email: string;
        password: string;
        loginBtn: string;
        loginFailedTitle: string;
        loginFailedText: string;
    };
    production: {
        ready: string;
        almostReady: string;
        inPreparation: string;
        emptyFulfillmentGroup: string;
        failedLoadingFulfillments: string;
        notPaid: string;
        fulfilledNotPaid: string;
        deletedTable: string;
    };
    settings: {
        secGeneral: string;
        location: string;
        secRoomPlan: string;
        room: string;
        secProduction: string;
        orderRooms: string;
        fulfillmentGroups: string;
        productionTileViewMode: string;
        save: string;
        failedSave: string;
        newOrdersViewMode: string;
        fulfilmentTileSize: string;
        orderStateMode: string;
        status: string;
        pleaseSelect: string;
    };
    items: {
        allOffers: string;
        availability: string;
        available: string;
        currentStock: string;
        designation: string;
        disableWarning: string;
        failedLoadingItems: string;
        insufficientStock: string;
        itemType: string;
        minimumStock: string;
        notAvailableToday: string;
        offer: string;
        offerCategory: string;
        open: string;
        search: string;
        searchTerm: string;
        standardPrice: string;
        stockNotificationLevel: string;
        stockSaveFailed: string;
    };
    orders: {
        date: string;
        orderNumber: string;
        state: string;
        cancellationState: string;
        useCase: string;
        tableName: string;
        totalIncTip: string;
        user: string;
        anonymousUser: string;
        fulfilmentTime: string;
        ready: string;
        scheduled: string;
    };
    orderDetails: {
        consumptionInclVat: string;
        discount: string;
        tip: string;
        total: string;
        totalCancelled: string;
        receipt: string;
        sendReceipt: string;
        printReceipt: string;
    };
    navigation: {
        rooms: string;
        production: string;
        settings: string;
        logout: string;
        reports: string;
        items: string;
        openBills: string;
        orders: string;
        payments: string;
    };
    general: {
        ok: string;
        cancel: string;
        error: string;
        failed: string;
        close: string;
        operationFailed: string;
        all: string;
        send: string;
        display: string;
        deletedUser: string;
        entities: {
            fulfillmentGroups: string;
            rooms: string;
            offers: string;
            users: string;
        };
        timeFormat: {
            start: string;
            end: string;
        };
        save: string;
        unknown: string;
    };
    salesReports: {
        title: string;
        reportCategory: string;
        article: string;
        cancellationQuantity: string;
        netQuantity: string;
        grossNetSales: string;
        grossCancellations: string;
        vatPercent: string;
        details: string;
        endUsers: string;
        dateRangeGenerated: string;
        discountQuantity: string;
        grossSalesDiscounts: string;
    };
    paymentMethodsReport: {
        paymentMethod: string;
        netQuantity: string;
        grossSalesNetChfInclTip: string;
        grossSalesPercent: string;
        cancellationQuantity: string;
        quantity: string;
        grossSalesAvg: string;
        tipNet: string;
        grossNetSales: string;
    };
    salesReportExport: {
        paymentMethodsReport: string;
        specialReports: string;
    };
    payments: {
        date: string;
        state: string;
        orders: string;
        paymentMethod: string;
        totalIncTip: string;
        tableName: string;
    };
    printOrderReceipt: {
        title: string;
        printReceipt: string;
        language: string;
        settings: string;
    };
    sendOrderReceipt: {
        title: string;
        sentTo: string;
        failedSending: string;
        receiver: string;
    };
    print: {
        noProductionSiteEnabledForRoom: string;
        printReceipt: string;
    };
    voucher: {
        invalidCode: string;
        codeExpired: string;
        codeNotApplicable: string;
        codeUsed: string;
        voucherCodeAlreadyApplied: string;
    };
    enums: {
        cancellationMode: {
            Amount: string;
            Positions: string;
            WholeOrder: string;
        };
        productionTileViewMode: {
            Detailed: string;
            Overview: string;
        };
        newOrdersViewMode: {
            AtTheTop: string;
            AtTheBottom: string;
        };
        fulfilmentTileSize: {
            Normal: string;
            Large: string;
        };
        itemAvailability: {
            Available: string;
            NotAvailable: string;
        };
        itemType: {
            MainItems: string;
            Options: string;
        };
        orderStateMode: {
            All: string;
            NotFulfilled: string;
            Ready: string;
            NotPaid: string;
        };
        paymentState: {
            Confirmed: string;
            Declined: string;
            Intented: string;
        };
        salesOrderSummary: {
            TotalExclTip: string;
            Tip: string;
            TotalInclTip: string;
            OrdersExclTip: string;
            OrdersInclTip: string;
        };
        orderState: {
            Canceled: string;
            Closed: string;
            FullyPaid: string;
            Open: string;
            TimedOut: string;
            NotPaid: string;
            ClosedNotPaid: string;
            PartiallyPaid: string;
        };
        cancellationState: {
            Cancelled: string;
            PartiallyCancelled: string;
        };
        language: {
            English: string;
            French: string;
            German: string;
            Italian: string;
        };
    };
    app: {
        title: string;
    };
    orderReceivedPopup: {
        received: string;
    };
};

const setEnglish = () => {
    trans = {
        cancellation: {
            cancellationSuccessful: "Cancellation successful",
            cancel: "Cancel",
        },
        login: {
            title: "Operator Login",
            email: "Email",
            password: "Password",
            loginBtn: "Log In",
            loginFailedTitle: "Login Failed",
            loginFailedText: "Email address or password invalid, or you do not have permission to use the Operator App",
        },
        production: {
            ready: "Ready",
            almostReady: "Ready shortly",
            inPreparation: "In preparation",
            emptyFulfillmentGroup: "Without allocation",
            failedLoadingFulfillments: "Orders could not be loaded.",
            notPaid: "Not paid",
            fulfilledNotPaid: "Fulfilled, not paid",
            deletedTable: "Deleted table",
        },
        settings: {
            secGeneral: "General",
            location: "Location",
            secRoomPlan: "Room Plan",
            room: "Default view",
            secProduction: "Production & Fulfilment",
            orderRooms: "Orders from rooms",
            fulfillmentGroups: "Fulfilment Groups",
            save: "Save",
            failedSave: "Settings could not be saved.",
            productionTileViewMode: "View",
            newOrdersViewMode: "New orders",
            fulfilmentTileSize: "Size",
            orderStateMode: "Order State",
            status: "Status",
            pleaseSelect: "Please select",
        },
        items: {
            allOffers: "All offers",
            availability: "Availability",
            available: "Available",
            currentStock: "Current stock",
            designation: "Name",
            disableWarning: "Increase stock and set the item available in order to sell it",
            failedLoadingItems: "Failed to load items.<br />Please try again later.",
            insufficientStock: "Stock level too low. Please increase it, reduce minimum stock or deactivate stock function.",
            itemType: "Item Type",
            minimumStock: "Minimum stock",
            notAvailableToday: "Not available today",
            offer: "Offer",
            offerCategory: "Offer category",
            open: "Open",
            search: "Search",
            searchTerm: "Search term...",
            standardPrice: "Standard price",
            stockNotificationLevel: "Stock notification level",
            stockSaveFailed: "Item stock could not be edited.",
        },
        orders: {
            date: "Date",
            orderNumber: "Order code / number",
            state: "Status",
            cancellationState: "Cancellation",
            useCase: "Application",
            tableName: "Table",
            totalIncTip: "Total incl. tip",
            user: "User",
            anonymousUser: "Anonymous end user",
            fulfilmentTime: "Fulfilment time",
            ready: "Ready",
            scheduled: "Scheduled",
        },
        orderDetails: {
            consumptionInclVat: "Consumption (incl. {0}% VAT)",
            discount: "Discount",
            tip: "Tip",
            total: "Total",
            totalCancelled: "Total cancelled",
            receipt: "Receipt",
            sendReceipt: "Send receipt",
            printReceipt: "Print receipt",
        },
        navigation: {
            rooms: "Room Plan",
            production: "Production & Fulfilment",
            settings: "Settings",
            logout: "Log Out",
            reports: "Reports",
            items: "Items",
            openBills: "Open Bills",
            orders: "Orders",
            payments: "Payments",
        },
        general: {
            ok: "Ok",
            cancel: "Cancel",
            error: "Error",
            failed: "Failed",
            close: "Close",
            all: "All",
            send: "Send",
            display: "Display",
            operationFailed: "The operation could not be performed.",
            deletedUser: "Deleted user",
            entities: {
                fulfillmentGroups: "Fulfillment groups",
                rooms: "Rooms",
                offers: "Offers",
                users: "Users",
            },
            timeFormat: {
                start: "Start",
                end: "End",
            },
            save: "Save",
            unknown: "Unknown",
        },
        salesReports: {
            title: "Sales report",
            reportCategory: "Reporting category",
            article: "Item",
            grossNetSales: "Gross sales Net CHF",
            grossCancellations: "Gross sales Cancellations CHF",
            netQuantity: "Number Net",
            vatPercent: "VAT rate",
            cancellationQuantity: "Number of cancellations",
            details: "Details",
            endUsers: "End users",
            dateRangeGenerated: "Generated <b>{0}</b>&ensp;&ensp;Start <b>{1}</b>&ensp;&ensp;End <b>{2}</b>",
            discountQuantity: "Number of discounts",
            grossSalesDiscounts: "Gross sales Discounts CHF",
        },
        paymentMethodsReport: {
            paymentMethod: "Payment method",
            netQuantity: "Number Net",
            grossSalesNetChfInclTip: "Gross sales Net CHF incl. tip",
            grossSalesPercent: "Gross sales %",
            cancellationQuantity: "Number of cancellations",
            quantity: "Number",
            grossSalesAvg: "Gross sales Ø CHF",
            tipNet: "Tip Net CHF",
            grossNetSales: "Gross sales Net CHF",
        },
        salesReportExport: {
            paymentMethodsReport: "Payment methods report",
            specialReports: "Special reports",
        },
        payments: {
            date: "Date",
            state: "State",
            orders: "Orders",
            paymentMethod: "Payment method",
            totalIncTip: "Total incl. tip",
            tableName: "Table name",
        },
        printOrderReceipt: {
            title: "Print receipt",
            printReceipt: "Print",
            language: "Language",
            settings: "Settings",
        },
        sendOrderReceipt: {
            title: "Send Receipt",
            sentTo: "Receipt was sent to {{receiver}}",
            failedSending: "Receipt could not be sent.",
            receiver: "Recipient",
        },
        print: {
            noProductionSiteEnabledForRoom: "No activated receipt printer is assigned to this table / room.",
            printReceipt: "Print Receipt",
        },
        voucher: {
            invalidCode: "Invalid code",
            codeExpired: "Code expired",
            codeNotApplicable: "Code not applicable",
            codeUsed: "Code used up",
            voucherCodeAlreadyApplied: "Code already applied",
        },
        enums: {
            cancellationMode: {
                Amount: "Custom amount",
                Positions: "Individual items",
                WholeOrder: "Entire order",
            },
            productionTileViewMode: {
                Detailed: "Detailed",
                Overview: "Overview",
            },
            newOrdersViewMode: {
                AtTheTop: "At the top",
                AtTheBottom: "At the bottom",
            },
            fulfilmentTileSize: {
                Normal: "Normal",
                Large: "Large",
            },
            itemAvailability: {
                Available: "Available",
                NotAvailable: "Not available",
            },
            itemType: {
                MainItems: "Main items",
                Options: "Options",
            },
            orderStateMode: {
                All: "All",
                NotFulfilled: "Not fulfilled",
                Ready: "Ready",
                NotPaid: "Not paid",
            },
            paymentState: {
                Confirmed: "Confirmed",
                Declined: "Declined",
                Intented: "Requested",
            },
            salesOrderSummary: {
                TotalExclTip: "Total (excl. tip)",
                Tip: "Tip",
                TotalInclTip: "Total (incl. tip)",
                OrdersExclTip: "Orders (excl. tip)",
                OrdersInclTip: "Orders (incl. tip)",
            },
            orderState: {
                Canceled: "Voided",
                Closed: "Done",
                FullyPaid: "Fully paid",
                Open: "Open",
                TimedOut: "Cancelled",
                NotPaid: "Not paid",
                ClosedNotPaid: "Fulfilled, not paid",
                PartiallyPaid: "Partially paid",
            },
            cancellationState: {
                Cancelled: "Cancelled",
                PartiallyCancelled: "Partially cancelled",
            },
            language: {
                English: "English",
                French: "French",
                German: "German",
                Italian: "Italian",
            },
        },
        app: {
            title: "Tastier Operator App",
        },
        orderReceivedPopup: {
            received: "Order Received",
        },
    };
};

const setGerman = () => {
    trans = {
        cancellation: {
            cancellationSuccessful: "Stornierung erfolgreich",
            cancel: "Stornieren",
        },
        login: {
            title: "Betreiber Login",
            email: "E-Mail",
            password: "Passwort",
            loginBtn: "Einloggen",
            loginFailedTitle: "Login Fehlgeschlagen",
            loginFailedText: "E-Mail-Adresse oder Passwort ungültig, oder Sie haben keine Berechtigung die Betreiber App zu nutzen",
        },
        production: {
            ready: "Bereit",
            almostReady: "In Kürze bereit",
            inPreparation: "In Vorbereitung",
            emptyFulfillmentGroup: "Ohne Zuteilung",
            failedLoadingFulfillments: "Bestellungen konnten nicht geladen werden.",
            notPaid: "Nicht bezahlt",
            fulfilledNotPaid: "Erfüllt, nicht bezahlt",
            deletedTable: "Gelöschter Tisch",
        },
        settings: {
            secGeneral: "Allgemein",
            location: "Standort",
            secRoomPlan: "Raumplan",
            room: "Standardansicht",
            secProduction: "Produktion & Erfüllung",
            orderRooms: "Bestellungen aus Räumen",
            fulfillmentGroups: "Erfüllungsgruppen",
            save: "Speichern",
            failedSave: "Einstellungen konnten nicht gespeichert werden.",
            productionTileViewMode: "Ansicht",
            newOrdersViewMode: "Neue Bestellungen",
            fulfilmentTileSize: "Grösse",
            orderStateMode: "Bestellstatus",
            status: "Status",
            pleaseSelect: "Bitte auswählen",
        },
        items: {
            allOffers: "Alle Angebote",
            availability: "Verfügbarkeit",
            available: "Verfügbar",
            currentStock: "Aktueller Bestand",
            designation: "Bezeichnung",
            disableWarning: "Bestand erhöhen und Artikel verfügbar setzen, um ihn zu verkaufen",
            failedLoadingItems: "Artikel konnten nicht geladen werden.<br />Bitte versuchen Sie es später erneut.",
            insufficientStock: "Bestand zu gering. Bitte erhöhen, Mindestbestand reduzieren oder Bestandsfunktion deaktivieren.",
            itemType: "Artikeltyp",
            minimumStock: "Mindestbestand",
            notAvailableToday: "Heute nicht verfügbar",
            offer: "Angebot",
            offerCategory: "Angebotskategorie",
            open: "Offen",
            search: "Suchen",
            searchTerm: "Suchbegriff...",
            standardPrice: "Standardpreis",
            stockNotificationLevel: "Meldebestand",
            stockSaveFailed: "Artikelbestand konnte nicht bearbeitet werden.",
        },
        orders: {
            date: "Datum",
            orderNumber: "Bestellcode / -Nummer",
            state: "Status",
            cancellationState: "Stornierung",
            useCase: "Anwendung",
            tableName: "Tisch",
            totalIncTip: "Total inkl. Trinkgeld",
            user: "Nutzer",
            anonymousUser: "Anonymer Endnutzer",
            fulfilmentTime: "Erfüllungszeit",
            ready: "Bereit",
            scheduled: "Geplant",
        },
        orderDetails: {
            consumptionInclVat: "Konsumation (inkl. {0}% MWST)",
            discount: "Rabatt",
            tip: "Trinkgeld",
            total: "Total",
            totalCancelled: "Total storniert",
            receipt: "Quittung",
            sendReceipt: "Quittung Schicken",
            printReceipt: "Quittung Drucken",
        },
        navigation: {
            rooms: "Raumplan",
            production: "Produktion & Erfüllung",
            settings: "Einstellungen",
            logout: "Ausloggen",
            reports: "Berichte",
            items: "Artikel",
            openBills: "Offene Rechnungen",
            orders: "Bestellungen",
            payments: "Zahlungen",
        },
        general: {
            ok: "Ok",
            cancel: "Abbrechen",
            close: "Schliessen",
            error: "Fehler",
            failed: "Fehlgeschlagen",
            all: "Alle",
            send: "Senden",
            operationFailed: "Der Vorgang konnte nicht ausgeführt werden.",
            display: "Anzeigen",
            deletedUser: "Gelöschter Nutzer",
            entities: {
                fulfillmentGroups: "Erfüllungsgruppen",
                rooms: "Räume",
                offers: "Angebote",
                users: "Nutzer",
            },
            timeFormat: {
                start: "Beginn",
                end: "Ende",
            },
            save: "Speichern",
            unknown: "Unbekannt",
        },
        salesReports: {
            title: "Verkaufsbericht",
            reportCategory: "Berichtskategorie",
            article: "Artikel",
            grossNetSales: "Bruttoumsatz Netto CHF",
            grossCancellations: "Bruttoumsatz Storno CHF",
            netQuantity: "Anzahl Netto",
            vatPercent: "MWST-Satz",
            cancellationQuantity: "Anzahl Storno",
            details: "Details",
            endUsers: "Endnutzer",
            dateRangeGenerated: "Erzeugt <b>{0}</b>&ensp;&ensp;Beginn <b>{1}</b>&ensp;&ensp;Ende <b>{2}</b>",
            discountQuantity: "Anzahl Rabatte",
            grossSalesDiscounts: "Bruttoumsatz Rabatte CHF",
        },
        paymentMethodsReport: {
            paymentMethod: "Zahlungsmittel",
            netQuantity: "Anzahl Netto",
            grossSalesNetChfInclTip: "Bruttoumsatz Netto CHF inkl. Trinkgeld",
            grossSalesPercent: "Bruttoumsatz %",
            cancellationQuantity: "Anzahl Storno",
            quantity: "Anzahl",
            grossSalesAvg: "Bruttoumsatz Ø CHF",
            tipNet: "Trinkgeld Netto CHF",
            grossNetSales: "Bruttoumsatz Netto CHF",
        },
        salesReportExport: {
            paymentMethodsReport: "Zahlungsmittelbericht",
            specialReports: "Besondere Berichte",
        },
        payments: {
            date: "Datum",
            state: "Status",
            orders: "Bestellungen",
            paymentMethod: "Zahlungsmittel",
            totalIncTip: "Total inkl. Trinkgeld",
            tableName: "Tischbezeichnung",
        },
        printOrderReceipt: {
            title: "Quittung drucken",
            printReceipt: "Drucken",
            language: "Sprache",
            settings: "Einstellungen",
        },
        sendOrderReceipt: {
            title: "Quittung Schicken",
            sentTo: "Quittung wurde an {{receiver}} gesendet",
            failedSending: "Quittung konnte nicht gesendet werden.",
            receiver: "Empfänger",
        },
        print: {
            noProductionSiteEnabledForRoom: "Diesem Tisch / Raum ist kein aktivierter Quittungsdrucker zugewiesen.",
            printReceipt: "Quittung Drucken",
        },
        voucher: {
            invalidCode: "Ungültiger Code",
            codeExpired: "Code abgelaufen",
            codeNotApplicable: "Code nicht anwendbar",
            codeUsed: "Code aufgebraucht",
            voucherCodeAlreadyApplied: "Code bereits angewendet",
        },
        enums: {
            cancellationMode: {
                Amount: "Manueller Betrag",
                Positions: "Einzelpositionen",
                WholeOrder: "Gesamte Bestellung",
            },
            productionTileViewMode: {
                Detailed: "Detailliert",
                Overview: "Überblick",
            },
            newOrdersViewMode: {
                AtTheTop: "Oben",
                AtTheBottom: "Unten",
            },
            fulfilmentTileSize: {
                Normal: "Normal",
                Large: "Gross",
            },
            itemAvailability: {
                Available: "Verfügbar",
                NotAvailable: "Nicht verfügbar",
            },
            itemType: {
                MainItems: "Hauptartikel",
                Options: "Optionen",
            },
            orderStateMode: {
                All: "Alle",
                NotFulfilled: "Nicht erfüllt",
                Ready: "Bereit",
                NotPaid: "Nicht bezahlt",
            },
            paymentState: {
                Confirmed: "Bestätigt",
                Declined: "Abgelehnt",
                Intented: "Angefordert",
            },
            salesOrderSummary: {
                TotalExclTip: "Total (exkl. Trinkgeld)",
                Tip: "Trinkgeld",
                TotalInclTip: "Total (inkl. Trinkgeld)",
                OrdersExclTip: "Bestellungen (exkl. Trinkgeld)",
                OrdersInclTip: "Bestellungen (inkl. Trinkgeld)",
            },
            orderState: {
                Canceled: "Storniert",
                Closed: "Erledigt",
                FullyPaid: "Vollständig bezahlt",
                Open: "Offen",
                TimedOut: "Abgebrochen",
                NotPaid: "Nicht bezahlt",
                ClosedNotPaid: "Erfüllt, nicht bezahlt",
                PartiallyPaid: "Teilweise bezahlt",
            },
            cancellationState: {
                Cancelled: "Storniert",
                PartiallyCancelled: "Teilstorniert",
            },
            language: {
                English: "Englisch",
                French: "Französisch",
                German: "Deutsch",
                Italian: "Italienisch",
            },
        },
        app: {
            title: "Tastier Betreiber-App",
        },
        orderReceivedPopup: {
            received: "Bestellung Empfangen",
        },
    };
};

const setFrench = () => {
    trans = {
        cancellation: {
            cancellationSuccessful: "Annulation réussie",
            cancel: "Annuler",
        },
        login: {
            title: "Connexion Opérateur",
            email: "E-mail",
            password: "Mot de passe",
            loginBtn: "Se Connecter",
            loginFailedTitle: "Échec de la connexion",
            loginFailedText: "E-mail ou mot de passe invalide, ou vous n'avez pas la permission d'utiliser l'App Opérateur",
        },
        production: {
            ready: "Prêt",
            almostReady: "Prêt sous peu",
            inPreparation: "En préparation",
            emptyFulfillmentGroup: "Sans allocation",
            failedLoadingFulfillments: "Les commandes n'ont pas pu être chargées.",
            notPaid: "Non payé",
            fulfilledNotPaid: "Exécuté, non payé",
            deletedTable: "Table supprimée",
        },
        navigation: {
            rooms: "Plan de Salle",
            production: "Production et Exécution",
            settings: "Paramètres",
            logout: "Se Déconnecter",
            reports: "Rapports",
            items: "Articles",
            openBills: "Notes impayées",
            orders: "Commandes",
            payments: "Paiements",
        },
        items: {
            allOffers: "Toutes les offres",
            availability: "Disponibilité",
            available: "Disponible",
            currentStock: "Stock actuel",
            designation: "Désignation",
            disableWarning: "Augmenter le stock et mettre l'article disponible afin de le vendre",
            failedLoadingItems: "Les articles n'ont pas pu être chargés.<br />Veuillez réessayer plus tard.",
            insufficientStock: "Stock trop faible. Veuillez l'augmenter, réduire le stock minimum ou désactiver la fonction de stock.",
            itemType: "Type d'article",
            minimumStock: "Stock minimum",
            notAvailableToday: "Non disponible aujourd'hui",
            offer: "Offre",
            offerCategory: "Catégorie de l'offre",
            open: "Libre",
            search: "Rechercher",
            searchTerm: "Terme de recherche...",
            standardPrice: "Prix standard",
            stockNotificationLevel: "Niveau du stock d'alerte",
            stockSaveFailed: "Le stock d'articles n'a pas pu être traité.",
        },
        orders: {
            date: "Date",
            orderNumber: "Code / Numéro de commande",
            state: "Statut",
            cancellationState: "Annulation",
            useCase: "Application",
            tableName: "Table",
            totalIncTip: "Total (y compris le pourboire)",
            user: "Utilisateur",
            anonymousUser: "Utilisateur final anonyme",
            fulfilmentTime: "Heure d'exécution",
            ready: "Prêt",
            scheduled: "Programmé",
        },
        orderDetails: {
            consumptionInclVat: "Consommation (incl. {0}% TVA)",
            discount: "Remise",
            tip: "Pourboire",
            total: "Total",
            totalCancelled: "Total annulé",
            receipt: "Reçu",
            sendReceipt: "Envoyer le Reçu",
            printReceipt: "Imprimer le Reçu",
        },
        settings: {
            secGeneral: "Général",
            location: "Site",
            secRoomPlan: "Plan de Salle",
            room: "Vue par défaut",
            secProduction: "Production et Exécution",
            orderRooms: "Commandes des salles",
            fulfillmentGroups: "Groupes d'Exécution",
            save: "Sauvegarder",
            failedSave: "Les paramètres n'ont pas pu être enregistrés.",
            productionTileViewMode: "Vue",
            newOrdersViewMode: "Nouvelles commandes",
            fulfilmentTileSize: "Taille",
            orderStateMode: "État de la commande",
            status: "Statut",
            pleaseSelect: "Veuillez sélectionner",
        },
        general: {
            ok: "Ok",
            cancel: "Annuler",
            close: "Fermer",
            error: "Erreur",
            failed: "Échoué",
            all: "Tous/Toutes les",
            send: "Envoyer",
            operationFailed: "L'opération n'a pas pu être réalisée.",
            display: "Afficher",
            deletedUser: "Utilisateur supprimé",
            entities: {
                fulfillmentGroups: "Groupes d'exécution",
                rooms: "Salles",
                offers: "Offres",
                users: "Utilisateur",
            },
            timeFormat: {
                start: "Début",
                end: "Fin",
            },
            save: "Sauvegarder",
            unknown: "Inconnu",
        },
        salesReports: {
            title: "Rapport des ventes",
            reportCategory: "Catégorie de rapport",
            article: "Article",
            grossNetSales: "Chiffre d'affaires brut Net CHF",
            grossCancellations: "Chiffre d'affaires brut Annulations CHF",
            netQuantity: "Nombre Net",
            vatPercent: "Taux de TVA",
            cancellationQuantity: "Nombre d'annulations",
            details: "Détails",
            endUsers: "Utilisateurs finaux",
            dateRangeGenerated: "Généré <b>{0}</b>  Début <b>{1}</b> Fin <b>{2}</b>",
            discountQuantity: "Nombre de remises",
            grossSalesDiscounts: "Chiffre d’affaires brut Remises CHF",
        },
        paymentMethodsReport: {
            paymentMethod: "Moyen de paiement",
            netQuantity: "Nombre Net",
            grossSalesNetChfInclTip: "Chiffre d'affaires brut Net CHF y compris pourboires",
            grossSalesPercent: "Chiffre d'affaires brut %",
            cancellationQuantity: "Nombre d'annulations",
            quantity: "Nombre",
            grossSalesAvg: "Chiffre d'affaires brut Ø CHF",
            tipNet: "Pourboire Net CHF",
            grossNetSales: "Chiffre d'affaires brut Net CHF",
        },
        salesReportExport: {
            paymentMethodsReport: "Rapport sur les moyens de paiement",
            specialReports: "Rapports spéciaux",
        },
        payments: {
            date: "Date",
            state: "Statut",
            orders: "Commandes",
            paymentMethod: "Moyen de paiement",
            totalIncTip: "Total inkl. Trinkgeld",
            tableName: "La désignation de la table",
        },
        printOrderReceipt: {
            title: "Imprimer le Reçu",
            printReceipt: "Imprimer",
            language: "Langue",
            settings: "Paramètres",
        },
        sendOrderReceipt: {
            title: "Envoyer le Reçu",
            sentTo: "Le reçu a été envoyé à {{receiver}}",
            failedSending: "Le reçu n'a pas pu être envoyé.",
            receiver: "Destinataire",
        },
        print: {
            noProductionSiteEnabledForRoom: "Aucune imprimante de reçus activée n'est attribuée à cette table / salle.",
            printReceipt: "Imprimer le Reçu",
        },
        voucher: {
            invalidCode: "Code invalide",
            codeExpired: "Code expiré",
            codeNotApplicable: "Code non applicable",
            codeUsed: "Code épuisé",
            voucherCodeAlreadyApplied: "Code déjà appliqué",
        },
        enums: {
            cancellationMode: {
                Amount: "Montant manuel",
                Positions: "Postes individuels",
                WholeOrder: "Commande entière",
            },
            productionTileViewMode: {
                Detailed: "Détaillée",
                Overview: "Aperçu",
            },
            newOrdersViewMode: {
                AtTheTop: "En haut",
                AtTheBottom: "En bas",
            },
            fulfilmentTileSize: {
                Normal: "Normale",
                Large: "Grande",
            },
            itemAvailability: {
                Available: "Disponible",
                NotAvailable: "Pas disponible",
            },
            itemType: {
                MainItems: "Articles principaux",
                Options: "Options",
            },
            orderStateMode: {
                All: "Tous",
                NotFulfilled: "Non exécuté",
                Ready: "Prêt",
                NotPaid: "Non payé",
            },
            paymentState: {
                Confirmed: "Confirmé",
                Declined: "Refusé",
                Intented: "Demandé",
            },
            salesOrderSummary: {
                TotalExclTip: "Total (hors pourboire)",
                Tip: "Pourboire",
                TotalInclTip: "Total (y compris le pourboire)",
                OrdersExclTip: "Commandes (hors pourboire)",
                OrdersInclTip: "Commandes (y compris le pourboire)",
            },
            orderState: {
                Canceled: "Annulé",
                Closed: "Fait",
                FullyPaid: "Entièrement payée",
                Open: "Ouvert",
                TimedOut: "Abandonnée",
                NotPaid: "Non payé",
                ClosedNotPaid: "Exécuté, non payé",
                PartiallyPaid: "Partiellement payé",
            },
            cancellationState: {
                Cancelled: "Annulée",
                PartiallyCancelled: "Partiellement annulée",
            },
            language: {
                English: "Anglais",
                French: "Français",
                German: "Allemand",
                Italian: "Italien",
            },
        },
        app: {
            title: "Application Opérateur Tastier",
        },
        orderReceivedPopup: {
            received: "Commande Reçue",
        },
    };
};

const setItalian = () => {
    trans = {
        cancellation: {
            cancellationSuccessful: "Cancellazione riuscita",
            cancel: "Annullare",
        },
        login: {
            title: "Accesso Operatore",
            email: "E-mail",
            password: "Password",
            loginBtn: "Log In",
            loginFailedTitle: "Accesso fallito",
            loginFailedText: "L'indirizzo e-mail o la password non sono validi, oppure non si ha il permesso di utilizzare l'App Operatore",
        },
        production: {
            ready: "Pronto",
            almostReady: "Pronto a breve",
            inPreparation: "In preparazione",
            emptyFulfillmentGroup: "Senza assegnazione",
            failedLoadingFulfillments: "Gli ordini non possono essere caricati.",
            notPaid: "Non pagato",
            fulfilledNotPaid: "Adempiuto, non pagato",
            deletedTable: "Tavolo cancellato",
        },
        settings: {
            secGeneral: "Generale",
            location: "Ubicazione",
            secRoomPlan: "Piano di Sala",
            room: "Vista predefinita",
            secProduction: "Produzione e Adempimento",
            orderRooms: "Ordini dalle sale",
            fulfillmentGroups: "Gruppi di Adempimento",
            save: "Salvare",
            failedSave: "Non è stato possibile salvare le impostazioni.",
            productionTileViewMode: "Vista",
            newOrdersViewMode: "Nuovi ordini",
            fulfilmentTileSize: "Dimensione",
            orderStateMode: "Stato dell'ordine",
            status: "Stato",
            pleaseSelect: "Per favore seleziona",
        },
        items: {
            allOffers: "Tutte le offerte",
            availability: "Disponibilità",
            available: "Disponibile",
            currentStock: "Scorte attuali",
            designation: "Designazione",
            disableWarning: "Aumentare le scorte e rendere disponibile l'articolo per venderlo",
            failedLoadingItems: "Non è stato possibile caricare gli articoli.<br />Si prega di riprovare più tardi.",
            insufficientStock: "Scorte troppo basse. Si prega di aumentarlo, di ridurre la scorta minima o di disattivare la funzione di scorta.",
            itemType: "Tipo di articolo",
            minimumStock: "Scorte minime",
            notAvailableToday: "Non disponibile oggi",
            offer: "Offerta",
            offerCategory: "Categoria di offerta",
            open: "Libero",
            search: "Cercare",
            searchTerm: "Termine di ricerca...",
            standardPrice: "Prezzo standard",
            stockNotificationLevel: "Livello di notifica delle scorte",
            stockSaveFailed: "Non è stato possibile modificare le scorte dell'articolo.",
        },
        orders: {
            date: "Data",
            orderNumber: "Codice / Numero d'ordine",
            state: "Stato",
            cancellationState: "Annullamento",
            useCase: "Applicazione",
            tableName: "Tavolo",
            totalIncTip: "Totale (mancia inclusa)",
            user: "Utente",
            anonymousUser: "Utente finale anonimo",
            fulfilmentTime: "Tempo di adempimento",
            ready: "Pronto",
            scheduled: "Programmato",
        },
        orderDetails: {
            consumptionInclVat: "Consumo (incl. {0}% IVA)",
            discount: "Sconto",
            tip: "Mancia",
            total: "Totale",
            totalCancelled: "Totale annullato",
            receipt: "Ricevuta",
            sendReceipt: "Inviare la Ricevuta",
            printReceipt: "Stampa ricevuta",
        },
        navigation: {
            rooms: "Piano di Sala",
            production: "Produzione e Adempimento",
            settings: "Impostazioni",
            logout: "Disconnettere",
            reports: "Rapporti",
            items: "Articoli",
            openBills: "Conti aperti",
            orders: "Ordini",
            payments: "Pagamenti",
        },
        general: {
            ok: "Ok",
            cancel: "Cancellare",
            close: "Chiudere",
            error: "Errore",
            failed: "Fallito",
            all: "Tutti/Tutte",
            send: "Inviare",
            operationFailed: "L'operazione non può essere eseguita.",
            display: "Mostrare",
            deletedUser: "Utente cancellato",
            entities: {
                fulfillmentGroups: "Gruppi di adempimento",
                rooms: "Sale",
                offers: "Offerte",
                users: "Utente",
            },
            timeFormat: {
                start: "Inizio",
                end: "Fine",
            },
            save: "Salvare",
            unknown: "Sconosciuto",
        },
        salesReportExport: {
            paymentMethodsReport: "Rapporto sui mezzi di pagamento",
            specialReports: "Rapporti speciali",
        },
        salesReports: {
            title: "Rapporto sulle vendite",
            reportCategory: "Categoria di rapporto",
            article: "Articolo",
            grossNetSales: "Fatturato lordo Netto CHF",
            grossCancellations: "Fatturato lordo Annullamenti CHF",
            netQuantity: "Numero Netto",
            vatPercent: "Aliquota IVA",
            cancellationQuantity: "Numero di annullamenti",
            details: "Dettagli",
            endUsers: "Utenti finali",
            dateRangeGenerated: "Generato <b>{0}</b>&ensp;&ensp;Inizio <b>{1}</b>&ensp;&ensp;Fine <b>{2}</b>",
            discountQuantity: "Numero di sconti",
            grossSalesDiscounts: "Fatturato lordo Sconti CHF",
        },
        paymentMethodsReport: {
            paymentMethod: "Mezzo di pagamento",
            netQuantity: "Numero Netto",
            grossSalesNetChfInclTip: "Fatturato lordo Netto CHF incl. mancia",
            grossSalesPercent: "Fatturato lorde %",
            cancellationQuantity: "Numero di annullamenti",
            quantity: "Numero",
            grossSalesAvg: "Fatturato lorde Ø CHF",
            tipNet: "Mancia Netta CHF",
            grossNetSales: "Fatturato lordo Netto CHF",
        },
        payments: {
            date: "Data",
            state: "Stato",
            orders: "Ordini",
            paymentMethod: "Mezzo di pagamento",
            totalIncTip: "Total inkl. Trinkgeld",
            tableName: "Il nome del tavolo",
        },
        printOrderReceipt: {
            title: "Stampare la ricevuta",
            printReceipt: "Stampare",
            language: "Stampare",
            settings: "Impostazioni",
        },
        sendOrderReceipt: {
            title: "Inviare la Ricevuta",
            sentTo: "La ricevuta è stata inviata a {{ricevente}}",
            failedSending: "Non è stato possibile inviare la ricevuta.",
            receiver: "Destinatario",
        },
        print: {
            noProductionSiteEnabledForRoom: "A questo tavolo / sala non è assegnata alcuna stampante per ricevute attiva.",
            printReceipt: "Stampare la Ricevuta",
        },
        voucher: {
            invalidCode: "Codice non valido",
            codeExpired: "Codice scaduto",
            codeNotApplicable: "Codice non applicabile",
            codeUsed: "Codice esaurito",
            voucherCodeAlreadyApplied: "Codice già applicato",
        },
        enums: {
            cancellationMode: {
                Amount: "Importo manuale",
                Positions: "Singole voci",
                WholeOrder: "Ordine intero",
            },
            productionTileViewMode: {
                Detailed: "Dettagliata",
                Overview: "Panoramica",
            },
            newOrdersViewMode: {
                AtTheTop: "In alto",
                AtTheBottom: "In fondo",
            },
            fulfilmentTileSize: {
                Normal: "Normale",
                Large: "Grande",
            },
            itemAvailability: {
                Available: "Disponibile",
                NotAvailable: "Non disponibile",
            },
            itemType: {
                MainItems: "Articoli principali",
                Options: "Opzioni",
            },
            orderStateMode: {
                All: "Tutti",
                NotFulfilled: "Non adempiuto",
                Ready: "Pronto",
                NotPaid: "Non pagato",
            },
            paymentState: {
                Confirmed: "Confermato",
                Declined: "Rifiutato",
                Intented: "Richiesto",
            },
            salesOrderSummary: {
                TotalExclTip: "Totale (esclusa la mancia)",
                Tip: "Mancia",
                TotalInclTip: "Totale (mancia inclusa)",
                OrdersExclTip: "Ordini (esclusa la mancia)",
                OrdersInclTip: "Ordini (mancia inclusa)",
            },
            orderState: {
                Canceled: "Stornato",
                Closed: "Fatto",
                FullyPaid: "Pagato per intero",
                Open: "Aperto",
                TimedOut: "Cancellato",
                NotPaid: "Non pagato",
                ClosedNotPaid: "Completato, Non pagato",
                PartiallyPaid: "Parzialmente pagato",
            },
            cancellationState: {
                Cancelled: "Annullato",
                PartiallyCancelled: "Parzialmente annullato",
            },
            language: {
                English: "Inglese",
                French: "Francese",
                German: "Tedesco",
                Italian: "Italiano",
            },
        },
        app: {
            title: "App Operatore Tastier",
        },
        orderReceivedPopup: {
            received: "Ordine Ricevuto",
        },
    };
};

switch (clientLanguage()) {
    case Language.English:
        setEnglish();
        break;
    case Language.German:
        setGerman();
        break;
    case Language.French:
        setFrench();
        break;
    case Language.Italian:
        setItalian();
        break;
    default:
        setEnglish();
        break;
}
